// extracted by mini-css-extract-plugin
module.exports = {"label":"FormRadioButton_label__18SIp","large":"FormRadioButton_large__3D_qc"};